import { useEffect, useState } from 'react'
import { get } from 'lodash'

import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'

const defaultBypassState = { isBypass: false, path: '/' }

const useBypassPath = () => {
    const [bypassPath, setBypassPath] = useState(defaultBypassState)

    useEffect(() => {
        const isBypass = get(StoreCheckout.CheckOutInstance().GetBypassPage(), 'isBypass')
        const targetPath = get(StoreCheckout.CheckOutInstance().GetBypassPage(), 'to')

        if (isBypass) {
            setBypassPath({ isBypass: true, path: targetPath })
        }
    }, [])

    return bypassPath
}

export default useBypassPath

